import {createPageHooks} from "../hooks/createPageHook";

export interface AddRecipientProps {
    userId: string;
    clientPolicyId: string;
    reportsLoading?: boolean;
    carrierId ?: number;
    strategyId ?: number;
    confirmButtonFlashing?: boolean;
}

export interface RecipientListingsProps {
    carrierId ?: number;
}


// page props for add new recipient pag
export const {
    usePageProp: useGetRecipientPageProps,
    useSetPageProp:  useSetRecipientPageProps,
    useClearPage: useClearRecipientPage,
} = createPageHooks<AddRecipientProps>();

// page props for recipient listing Gifter Detail page
export const {
    usePageProp: useGetRecipientListPageProps,
    useSetPageProp:  useSetRecipientListPageProps,
    useClearPage: useClearRecipientListPage,
} = createPageHooks<RecipientListingsProps>();



export interface SteppersProps {
    // fetch on basis of carrierId and strategyId
    estimationData ?: any;
}
// props for add new steppers
export const {
    usePageProp: useGetStepperProps,
    useSetPageProp:  useSetStepperProps,
    useClearPage: useClearStepperProps,
} = createPageHooks<SteppersProps>();

// use these functions to get props in component which not made for in specific page. here we did not define types. for any page specific create you own hooks
export const {
    usePageProp: useGetPageProps,
    useSetPageProp:  useSetPageProps,
    useClearPage: useClearPage,
} = createPageHooks<any>();